import ReviewsSection from './Component';

export default ReviewsSection;